import React from "react";
import "./AboutFalse.css";

function AboutFalse(props) {
  const { aboutSohniJuneja, line12 } = props;

  return (
    <div className="accordian-1">
      <div className="frame-23">
        <div className="frame-22">
          <div className="about-sohni-juneja poppins-medium-tundora-16px">{aboutSohniJuneja}</div>
          <img className="vector-1" src="/img/vector-1@2x.png" />
        </div>
        <img className="line-12-1" src={line12} />
      </div>
    </div>
  );
}

export default AboutFalse;
